module.exports = __webpack_public_path__ + "static/media/calender_icon.a924a537.svg";